import { initRouter, navigate } from './router.js';
import { clearElement } from './utils/dom.js';
import { closeModal } from './components/modal.js';
import { renderBottomNav } from './components/bottom-nav.js';
import { renderHomePage } from './pages/home.js';
import { renderStoreView, resetStoreViewState } from './pages/store-view.js';
import { renderStoreSettings } from './pages/store-settings.js';
import { renderQuickList } from './pages/quick-list.js';
import { renderShoppingMode } from './pages/shopping-mode.js';
import { renderCommunityPage } from './pages/community.js';
import { renderLoginPage } from './pages/login.js';
import { renderAccountPage } from './pages/account.js';
import { isLoggedIn } from './utils/auth.js';
import { pullData, joinStore } from './api/user-sync.js';
import { showToast } from './utils/dom.js';

const PAGES_WITH_BOTTOM_NAV = ['/', '/quick-list', '/community', '/account', '/login'];

/**
 * Initialise l'application : router + rendu des pages.
 */
export function initApp() {
  const container = document.getElementById('app');
  if (!container) {
    console.error('Conteneur #app introuvable');
    return;
  }

  if (isLoggedIn()) {
    pullData().catch(() => {});
  }

  initRouter(async (route) => {
    closeModal();
    resetStoreViewState();
    clearElement(container);

    const showNav = PAGES_WITH_BOTTOM_NAV.includes(route.path);

    switch (route.path) {
      case '/':
        await renderHomePage(container);
        break;

      case '/store/:id':
        if (route.params.id != null) {
          await renderStoreView(container, route.params.id);
        } else {
          navigate('/');
        }
        break;

      case '/store/:id/settings':
        if (route.params.id != null) {
          await renderStoreSettings(container, route.params.id);
        } else {
          navigate('/');
        }
        break;

      case '/store/:id/shopping':
        if (route.params.id != null) {
          await renderShoppingMode(container, route.params.id);
        } else {
          navigate('/');
        }
        break;

      case '/quick-list':
        await renderQuickList(container);
        break;

      case '/community':
        await renderCommunityPage(container);
        break;

      case '/login':
        await renderLoginPage(container);
        break;

      case '/account':
        await renderAccountPage(container);
        break;

      case '/join/:code':
        if (route.params.code) {
          if (!isLoggedIn()) {
            localStorage.setItem('grocewise-pending-join', route.params.code);
            navigate('/login');
          } else {
            try {
              await joinStore(route.params.code);
              await pullData();
              showToast('Liste rejointe !', 2000, 'success');
            } catch (err) {
              showToast(err.message || 'Code invalide', 3000, 'error');
            }
            navigate('/');
          }
        } else {
          navigate('/');
        }
        break;

      default:
        navigate('/');
        break;
    }

    // Barre de navigation en bas sur les pages principales
    if (showNav) {
      container.appendChild(renderBottomNav());
    }
  });
}
